import { render, staticRenderFns } from "./UnidadeList.vue?vue&type=template&id=f87ec67c"
import script from "./UnidadeList.vue?vue&type=script&lang=js"
export * from "./UnidadeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports